/** Paleta única dos segmentos do CRM (badge, relatório, quadro e lista usam as mesmas cores). */
const COR_POR_SEGMENTO: {[chave: string]: string} = {
  CAMPEAO: '#7c5cff', 'Campeões': '#7c5cff',
  FIEL: '#16a34a', 'Fiéis': '#16a34a',
  NOVO: '#2563eb', 'Novos': '#2563eb',
  ESFRIANDO: '#d97706', 'Esfriando': '#d97706',
  SUMIDO: '#ea580c', 'Sumidos': '#ea580c',
  PERDIDO: '#64748b', 'Perdidos': '#64748b',
  SEM_PEDIDO: '#0d9488', 'Sem pedido': '#0d9488'
};

export class ColorUtils {
  public static corDoSegmento(segmento: string): string {
    return COR_POR_SEGMENTO[segmento] || '#28B4C8';
  }

  public static obtenhaCorStatic(registro: any) {
    return ColorUtils.corDoSegmento(registro && registro.rotulo);
  }
}
